var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFurnishings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-window-189840 1",
    clipPath: "url(#clip0_5273_49419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.35 6.4C2.35 6.4 3.3 5.8 3.65 4.85L4 4L4.35 4.85C4.75 5.8 5.65 6.4 6.65 6.4C7.65 6.4 8.6 5.8 8.95 4.85L9.35 4L9.7 4.85C10.1 5.8 11 6.4 12 6.4C13 6.4 13.95 5.8 14.3 4.85L14.65 4L15 4.85C15.4 5.8 16.3 6.4 17.3 6.4C18.3 6.4 19.25 5.8 19.6 4.85L20 4L20.35 4.85C20.75 5.8 21.65 6.4 22.65 6.4C23.05 6.4 23.4 6.3 23.75 6.15V0.75H0.25V6.1C0.6 6.3 0.95 6.4 1.35 6.4Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.7 14.35L4.8 14.2C5.85 12.65 6.7 9.55 7.25 7.1C7.05 7.15 6.85 7.15 6.65 7.15C5.55 7.15 4.6 6.65 4 5.75C3.4 6.6 2.4 7.15 1.35 7.15C0.95 7.15 0.6 7.1 0.25 6.95V24.25H6.45L4.7 14.35Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.65 7.15C21.55 7.15 20.6 6.65 20 5.75C19.4 6.6 18.4 7.15 17.35 7.15C17.15 7.15 16.95 7.15 16.75 7.1C17.3 9.55 18.15 12.65 19.2 14.2L19.3 14.35L17.55 24.25H23.75V6.95C23.4 7.05 23.05 7.15 22.65 7.15Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.90039 10.8H21.1504V12H2.90039V10.8Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.4502 5.05H12.5002V24.25H11.4502V5.05Z",
    fill: "#656565"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5273_49419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnishings);
export default __webpack_public_path__ + "static/media/furnishings.2f4ab4f54bde8f23e4d97953d4407ff4.svg";
export { ForwardRef as ReactComponent };